<template>
  <div class="checkout-pkg">
    <ul>
      <li>
        <h3>商品名称</h3>
        <h4>{{ content.productName }}</h4>
      </li>
      <li>
        <h3>期限</h3>
        <h4>{{ content.limitTime }} 天</h4>
      </li>
      <li>
        <h3>金额</h3>
        <h4>¥ {{ content.totalPrice }}</h4>
      </li>
      <li @click="ticketShowHandler">
        <h3>优惠券</h3>
        <h4 class="ticket" :class="{ active: defaultTicketDetail }">
          {{ preferentialAmount }}
          <span class="arrow"></span>
        </h4>
      </li>
    </ul>
    <div class="agreement">
      <img :src="hasRead ? hasReadImg : noReadImg" alt="" @click="hasRead = !hasRead" />
      <p class="tip">勾选即代表已同意<a class="name" href="/agreement/buy_agreement.html">《VIP课程包购买协议》</a></p>
    </div>
    <div class="sticky">
      <p class="text">
        实收金额: <span>¥ {{ totalPrice }}</span>
      </p>
      <a :class="{ buy_disabled: !hasRead }" class="buy" @click="buy">立即支付</a>
    </div>
    <ticket-dialog @ticketChange="ticketChangeHandler" v-show="ticketShow" :active="ticketActive" :goodsNum="goodsNum"></ticket-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { LocalStorageUtil } from '@/utils'
import { wechatSharePkgPage, wechatPay } from '@/mixins'
const hasReadImg = '/images/select_active_checkout.png'
const noReadImg = '/images/select_checkout.png'
import store from '@/store'
import { isEmpty } from 'lodash'
import { Dialog } from '@/components/ticket'

export default {
  mixins: [wechatSharePkgPage, wechatPay],
  components: { ticketDialog: Dialog },
  data() {
    return {
      goodsNum: this.$route.params.id,
      goodsDetail: {},
      correlationId: '',
      packageDetail: {},
      prepayMap: {},
      defaultTicketDetail: null,
      hasRead: true,
      hasReadImg,
      noReadImg,
      ticketShow: false,
      ticketActive: 0,
    }
  },
  created() {
    this.initData()
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler: function(query) {
        if (query.mode === 'complete') {
          this.$createDialog({
            type: 'confirm',
            icon: 'cubeic-alert',
            title: '提示',
            content: '是否完成支付',
            confirmBtn: {
              text: '完成支付',
              active: true,
              disabled: false,
              href: 'javascript:;',
            },
            cancelBtn: {
              text: '重新支付',
              active: false,
              disabled: false,
              href: 'javascript:;',
            },
            onConfirm: async () => {
              // this.$nextTick(() => {
              //   let path = ''
              //   if (this.packageDetail.type == 0) {
              //     path = '/goods/pkg'
              //   } else if (this.packageDetail.type == 1) {
              //     path = '/goods/parentPkg'
              //   } else if (this.packageDetail.type == 2) {
              //     path = '/goods/aiPkg'
              //   }
              //   this.$router.push(path)
              // })
              this.$router.go(-3)
            },
            onCancel: () => {
              this.$router.go(-2)
            },
          }).show()
        }
      },
    },
    correlationId: {
      // immediate: true,
      handler: function(id) {
        if (id) {
          this.$api
            .payment_v1_product_member_package_detail_id_get({
              path: {
                id,
              },
            })
            .then((e) => {
              this.packageDetail = e
            })
        }
      },
    },
    userInfo: {
      immediate: true,
      handler: function() {
        this.$setShareConfig(this.getShareText())
      },
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   let contextInfo =
  //     store.getters["auth/contextInfo"];
  //   if (!isEmpty(contextInfo)) {
  //     next();
  //   } else {
  //     next({
  //       path: "/account/bind-inviter",
  //       query: {
  //         redirect: `/goods/checkoutPkg/${to.params.id}`
  //       }
  //     });
  //   }
  // },
  computed: {
    ...mapGetters({
      userInfo: 'auth/userInfo',
      uid: 'auth/uid',
      downloadPath: 'externalInterface/downloadApp',
      purchaseQualificationInviteCode: 'auth/purchaseQualificationInviteCode',
    }),
    content() {
      return {
        productName: this.packageDetail.type == 0 ? '智伴儿童优学VIP课程包' : (this.goodsDetail && this.goodsDetail.name) || '',
        packageName: this.packageDetail.type == 0 ? '智伴儿童优学VIP课程包' : this.packageDetail.name,
        limitTime: (this.packageDetail && this.packageDetail.days) || 0,
        totalPrice: (this.goodsDetail && this.goodsDetail.price) || 0,
      }
    },
    preferentialAmount() {
      return this.defaultTicketDetail ? (this.defaultTicketDetail.preferentialAmount ? `-￥${this.defaultTicketDetail.preferentialAmount}` : '未选择优惠券') : '暂无优惠券'
    },
    totalPrice() {
      return (Number(this.content.totalPrice) - Number((this.defaultTicketDetail && this.defaultTicketDetail.preferentialAmount) || 0)).toFixed(2)
    },
  },
  methods: {
    ...mapMutations({
      setLoading: 'setLoadingShow',
      setToast: 'setToastShow',
    }),
    initData() {
      this.setLoading({ show: true })
      this.$api
        .payment_v1_goods_app_goodsNum_get({
          path: {
            goodsNum: this.goodsNum,
          },
        })
        .then((e) => {
          this.setLoading({ show: false })
          this.goodsDetail = e
          this.correlationId = e.correlationId
        })
    },
    ticketChangeHandler({ ticket, active }) {
      this.defaultTicketDetail = ticket
      this.ticketActive = active
      this.ticketShow = false
    },
    ticketShowHandler() {
      this.ticketShow = !!this.defaultTicketDetail
    },
    buy() {
      if (!this.hasRead) return
      this.setLoading({
        show: true,
      })
      let params = {
        goodsNum: this.goodsNum,
        uid: this.uid,
        openId: LocalStorageUtil.getOpenId(),
        // inviteCode: this.purchaseQualificationInviteCode,
        // ticketNum: '8XXAnWWFSAo3vq0e'
      }
      if (this.purchaseQualificationInviteCode && this.purchaseQualificationInviteCode != 100) {
        params.inviteCode = this.purchaseQualificationInviteCode
      }
      if (this.defaultTicketDetail && this.defaultTicketDetail.ticketNum) {
        params.ticketNum = this.defaultTicketDetail.ticketNum
      }
      if (isEmpty(LocalStorageUtil.getOpenId())) {
        this.payForApp(params)
        return
      }
      for (let value of Object.values(params)) {
        if (!value) {
          console.info(params)
          return
        }
      }
      this.wechatPay(params, (res) => {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          this.setLoading({
            show: true,
            txt: '更新数据中',
          })
          setTimeout(() => {
            this.setLoading({
              show: false,
            })
            this.showCompeleteBtn()
            this.$router.go(-1)
          }, 500)
        } else {
          this.setLoading({
            show: false,
          })
          this.setToast({
            show: true,
            content: {
              txt: '支付失败，请重试!',
              type: 'txt',
            },
          })
        }
      })
    },
    payForApp(params) {
      this.$api
        .payment_v1_order_wechat_h5_order_create_post({
          data: params,
        })
        .then((e) => {
          this.setLoading({
            show: false,
          })
          let url = e.prepayMap.url
          location.href = url + '&redirect_url=' + encodeURIComponent(`${location.href}?mode=complete`)
        })
    },
    showCompeleteBtn() {
      this.$store.dispatch('createDialog', {
        type: 'confirm',
        title: '开通VIP成功',
        content: `<div style="font-size:12px"><div class="text">体验课程包步骤：<br/>
1.打开手机应用商店，搜索下载【智伴优学】APP<br/>
2.安装APP后，登录点击首页下方【VIP】，进入VIP页面畅听已够课程包内容<br/><br/></div>
<p style="font-size:12px">或立即前往智伴优学APP-VIP页面畅听海量内容</p></div>`,
        confirmBtn: {
          text: '立即前往',
          active: true,
          disabled: false,
          href: this.downloadPath,
        },
        cancelBtn: {
          text: '暂不前往',
          active: false,
          disabled: false,
          href: 'javascript:;',
        },
      })
    },
  },
}
</script>
<style scoped>
.checkout-pkg {
  width: 100vw;
  height: 100vh;
  position: relative;
}
ul {
  padding: 0 16px;
}
ul li {
  display: flex;
  font-size: 16px;
  line-height: 50px;
  border-bottom: 1px solid #f4f4f4;
}
ul li h3 {
  flex: 1 1 auto;
  min-width: 100px;

  color: #4f4f4f;
}
ul li h4 {
  /* flex: 0 0 auto; */
  color: #959595;
}

.sticky {
  position: absolute;
  bottom: 0;
  display: flex;
  line-height: 52px;
  width: 100vw;
}
.sticky .text {
  flex: 1 1 atuo;
  width: 100vw;
  border-top: 1px solid #f4f4f4;
  box-sizing: border-box;
  color: #4f4f4f;
  font-size: 16px;
  padding-left: 16px;
}
.sticky .text span {
  color: #fe2c2a;
}
.sticky .buy {
  width: 152px;
  flex: 0 0 auto;
  background: #ff6886;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
}
.sticky .buy_disabled {
  background: #e6e6e6;
}
.checkout-pkg >>> .van-dialog__content {
  text-align: center;
  padding-top: 15px;
}
.checkout-pkg >>> .van-dialog__content p {
  line-height: 40px;
  height: 40px;
  color: #bbbcbd;
}
.checkout-pkg >>> .van-dialog__content p:first-of-type {
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
  color: red;
}

.agreement {
  padding: 18px 32px 0;
}
.agreement > img {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
.agreement .tip {
  display: inline-block;
  font-size: 14px;
  line-height: 20px;
  color: #959595;
  margin-left: 8px;
}
.agreement .tip .name {
  color: #40b8e8;
}
.ticket {
  position: relative;
}
.arrow {
  width: 5px;
  height: 9px;
  display: inline-block;
  background: url('/images/ticket/ticket3.png') no-repeat left;
  background-size: 200%;
  vertical-align: middle;
  margin-left: 6px;
}
.ticket.active {
  color: #ff6886;
}
.ticket.active .arrow {
  background-position: right;
}
</style>
